import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatSortModule } from '@angular/material/sort';

import { MgEmptyStateModule } from '@app/src/app/components/EmptyState';
import { FileInputUploadModule } from '@app/src/app/components/Input/FileInputUpload';
import { MgImageModule } from '@app/src/app/components/MgImage';
import { MgFormFieldModule } from '@app/src/app/form-field';
import { MgIconModule } from '@app/src/app/icon';
import { MgPipesModule } from '@app/src/app/pipes';

import { FormModule } from '@shared/components/form';
import { GenericModule } from '@shared/components/generic';
import { ManagerOverlayModule } from '@shared/components/manager-overlay';
import { OverlayModule } from '@shared/components/modal-overlay';
import { MobileCardModule } from '@shared/components/tables/mobile-card/mobile-card.module';
import { TextModule } from '@shared/components/text';
import { ArrayPipesModule } from '@shared/pipes';

import { PmRewardsEditComponent } from './components/pm-rewards-edit/pm-rewards-edit.component';
import { PmRewardsComponent } from './pm-rewards.component';
import { PmRewardsService } from './services';

@NgModule({
  imports: [
    // Minga dependencies
    MgEmptyStateModule,
    ManagerOverlayModule,
    MgImageModule,
    MgPipesModule,
    ArrayPipesModule,
    MgIconModule,
    MgFormFieldModule,
    OverlayModule,
    FormModule,
    FileInputUploadModule,
    TextModule,
    GenericModule,
    MobileCardModule,

    // External dependencies
    CommonModule,
    FlexLayoutModule,
    MatTableModule,
    MatSortModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  declarations: [PmRewardsComponent, PmRewardsEditComponent],
  exports: [PmRewardsComponent],
  providers: [PmRewardsService],
})
export class PmRewardsModule {}
